var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10.0 10.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55555556,0 L5.55555556,7.77777778 L0,7.77777778 L0,0 L5.55555556,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.62797375,0 C2.94771022,0.000919977696 3.21486404,0.115521656 3.3480169,0.435340293 C3.51424594,0.836001974 3.67369013,1.24199397 3.80260245,1.65686981 C3.89928668,1.96691621 4.0621233,2.18279379 4.34539116,2.31516317 C4.66767196,2.46618864 4.98486411,2.62965149 5.30205626,2.79222597 C5.53104525,2.9094928 5.61331167,3.12359361 5.51577932,3.33058734 C5.41739887,3.54024622 5.20876445,3.60776349 4.97807925,3.49493858 C4.53367099,3.27817262 4.08332598,3.07206728 3.65163933,2.82864976 C3.49473947,2.73981125 3.37854876,2.56479938 3.25811752,2.41643907 C3.19790189,2.34181472 3.16991435,2.23876205 3.10376198,2.10017397 C3.02064746,2.49905888 2.95958373,2.85352454 2.87053245,3.19999473 C2.81116494,3.43186324 2.85526652,3.61131703 2.97824209,3.81120368 C3.60499343,4.82485108 4.21902316,5.84738233 4.83220478,6.8690252 C5.06543431,7.25724949 4.8915723,7.70144204 4.47939212,7.7698477 C4.21308641,7.81426695 4.03498386,7.66768341 3.89759047,7.44025682 C3.24200348,6.34843153 2.58217595,5.26015978 1.92319653,4.17011126 C1.82142364,4.00220648 1.73661291,3.81831076 1.61448545,3.66906206 C1.38549646,3.39010914 1.37531917,3.09960721 1.46437044,2.75846733 C1.58225737,2.30450255 1.65773892,1.83898875 1.76375234,1.3175067 C1.52119364,1.53516105 1.29559708,1.6870749 1.137001,1.89673379 C1.01572165,2.05753149 0.95041738,2.28406969 0.911404441,2.4919518 C0.846948282,2.84108715 0.826593705,3.19910635 0.781644015,3.55268362 C0.750264042,3.79610113 0.567920959,3.94179629 0.338931971,3.91692151 C0.135386203,3.89471188 -0.0206655517,3.71792325 0.00223334713,3.4878315 C0.0607527552,2.91482311 0.122664593,2.34181472 0.215108295,1.77413664 C0.240551516,1.6213344 0.355894118,1.4605367 0.471236719,1.35037695 C0.805391021,1.0314467 1.15396315,0.728507376 1.50847203,0.434451908 C1.83329715,0.163494451 2.20222385,-0.00263356271 2.62797375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.22222222,0 L2.22222222,3.33333333 L0,3.33333333 L0,0 L2.22222222,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50963559,0 C1.75209722,0.311692077 1.97351183,0.594389543 2.19324268,0.87869782 C2.21008029,0.90205459 2.22860167,0.940714073 2.22018286,0.962460032 C2.11747342,1.24113047 2.0576999,1.5463793 1.89521693,1.78880647 C1.73778525,2.02438769 1.56667301,2.2513108 1.39082519,2.47521363 L0.858019971,3.14349917 C0.710690857,3.32954793 0.490960008,3.37867768 0.283857368,3.29169385 C0.0893829379,3.20954245 -0.0326897563,3.00980179 0.00772051489,2.80442329 C0.0254000085,2.71743945 0.0742290862,2.62965021 0.129793209,2.55635828 C0.415190749,2.17781751 0.714900261,1.80974702 0.994404636,1.42717923 C1.09290467,1.29428726 1.16699017,1.13803851 1.22002865,0.982595179 C1.32526373,0.670097696 1.40776804,0.35035156 1.50963559,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.22222222,0 L2.22222222,2.22222222 L0,2.22222222 L0,0 L2.22222222,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11421938,0 C1.72761379,0 2.22324467,0.498701077 2.22222222,1.11594585 C2.22222222,1.72808098 1.71737348,2.22780399 1.1050031,2.22269435 C0.507993178,2.21758471 0.00826617632,1.7178617 7.393039e-05,1.11901164 C-0.0070942848,0.518117717 0.507993178,0 1.11421938,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 2.222222222222222)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "9.10729825e-18,0 5.55555556,0 5.55555556,7.77777778 9.10729825e-18,7.77777778 9.10729825e-18,0",
    stroke: "none",
    fill: "#282828"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 6.666666666666665)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.9400973716039474e-05 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.94009725e-05,0 2.22228162,0 2.22228162,3.33333333 5.94009725e-05,3.33333333 5.94009725e-05,0",
    stroke: "none",
    fill: "#282828"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.222222222222626 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 -0.0005109642179630391)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0.000510964218 2.22222222,0.000510964218 2.22222222,2.22273319 0,2.22273319 0,0.000510964218",
    stroke: "none",
    fill: "#282828"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.39e8bf9994ce5443a947eb1fe9fe0c4b.svg";
export { ForwardRef as ReactComponent };